
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenu as BaseSidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";
import { menuItems } from "./MenuItems";

interface SidebarMenuProps {
  onMenuClick: (path: string, requiresSubscription: boolean, productId?: string) => void;
}

export function SidebarMenu({ onMenuClick }: SidebarMenuProps) {
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Menu</SidebarGroupLabel>
      <SidebarGroupContent>
        <BaseSidebarMenu>
          {menuItems.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton 
                onClick={() => onMenuClick(item.path, item.requiresSubscription, item.productId)}
              >
                <item.icon className="h-4 w-4 mr-2" />
                <span>{item.title}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </BaseSidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
